module.exports = __webpack_public_path__ + "img/cellarExample.06a3c67d.jpg";